import React from "react";
import { Box, IconButton, Typography, Drawer } from "@mui/material";
import IsMobile from "../../../../hooks/isMobile";
import CloseIcon from "../../../../assets/svg-fc/CrossIconSvg";
import EventDetailsFields from "./EventDetailsFields/EventDetailsFields";
import RecentQuotes from "./RecentQuotes/RecentQuotes";
import { iEventType } from "../../../../types/eventTypes";
import { ICorporateEvent } from "../../../../interfaces/corporateEvent";
import { ICorporateEventMessage } from "../../../../interfaces/corporateEvent";
import { getEventTypeFromEventObject } from "../../../../helpers/common";
import { EventStatusEnum } from "../../../../types/eventTypes";
import { CorporateEventStatusEnum } from "../../../../constants/enums";
import { IEventDetailMessages } from "../../../../types/eventTypes";
import "./EventDetailsDrawer.scss";
import { BUTTON_COLOR, BUTTON_VARIANT } from "../../../../types/coreButtonTypes";
import CoreButtons from "../../../core-components/button/CoreButtons";
import CrossIconSvg from "../../../../assets/svg-fc/CrossIconSvg";

interface EventDetailsDrawerProps {
	open: boolean;
	chatMessage: IEventDetailMessages | ICorporateEventMessage;
	eventDetail: iEventType | ICorporateEvent;
	recentEventStatus?: EventStatusEnum;
	showDeclineEventButtonValue?: boolean;
	onClose: () => void;
	handleStatusChange?: (status: EventStatusEnum | CorporateEventStatusEnum) => void;
}

const EventDetailsDrawer: React.FC<EventDetailsDrawerProps> = ({
	open,
	onClose,
	eventDetail,
	chatMessage,
	recentEventStatus,
	handleStatusChange,
	showDeclineEventButtonValue,
}) => {
	const isMobile = IsMobile();
	const eventType = getEventTypeFromEventObject(eventDetail);

	const drawerContent = (
		<Box className="eventDetailsDrawerContent">
			{/* Header */}
			<Box className="eventDetailsDrawerHeader">
				<Typography className="eventDetailsDrawerTitle">Event Details</Typography>
				<IconButton className="eventDetailsDrawerCloseButton" onClick={onClose} size="small">
					<CloseIcon size="18" />
				</IconButton>
			</Box>

			{/* Content */}
			<Box className="eventDetailsDrawerBody">
				{eventDetail && (
					<>
						{chatMessage && (
							<EventDetailsFields eventDetail={eventDetail} chatMessage={chatMessage} eventType={eventType} />
						)}
						<RecentQuotes eventType={eventType} eventId={eventDetail.id} eventStatus={eventDetail.status} />
					</>
				)}

				{/* Event decline button */}
				{showDeclineEventButtonValue && (
					<Box className="eventDetailsDrawerDeclineButton">
						<CoreButtons
							buttonText="Decline Event"
							variant={BUTTON_VARIANT.OUTLINED}
							color={BUTTON_COLOR.ERROR}
							startIcon={<CrossIconSvg />}
							onclick={() => handleStatusChange?.(CorporateEventStatusEnum.Cancelled)}
						/>
					</Box>
				)}
			</Box>
		</Box>
	);

	// Mobile: Use Drawer as bottom sheet
	if (isMobile) {
		return (
			<Drawer
				anchor="bottom"
				open={open}
				onClose={onClose}
				slotProps={{
					paper: {
						className: "eventDetailsDrawerMobile",
					}
				}}
			>
				{drawerContent}
			</Drawer>
		);
	}

	// Desktop: Use inline Box (existing behavior)
	const classNames = open ? "desktop__open" : "desktop__closed";
	return <Box className={`eventDetailsDrawer ${classNames}`}>{drawerContent}</Box>;
};

export default EventDetailsDrawer;
